import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
const SIZE = {
    md: 'rounded-r-[var(--radius-sm)] border-l-[length:var(--component-quote-rule)] border-foreground bg-[color:var(--surface-panel)] px-[var(--space-3-5)] py-[var(--space-3)] text-[length:var(--fs-ui-title)] leading-[var(--lh-snug)] text-foreground',
    body: 'italic text-[length:var(--fs-ui-body)] leading-[var(--lh-snug)] text-[color:var(--text-secondary)]',
    sm: 'italic text-[length:var(--fs-ui-meta)] leading-[var(--lh-snug)] text-muted-foreground'
};
/** A verbatim quote: question as written, "as written" text, or a comment anchor. */ export const SpecraQuote = /*#__PURE__*/ React.forwardRef(({ className, size = 'md', ...props }, ref)=>/*#__PURE__*/ _jsx("blockquote", {
        className: cn('m-0', SIZE[size], className),
        ref: ref,
        ...props
    }));
SpecraQuote.displayName = 'SpecraQuote';
